
import Button from 'react-bootstrap/Button';
import barigo from '../assets/altimiter/barigo.png'
import barigoArm from '../assets/altimiter/barigoArm.png'
import { Row } from 'react-bootstrap';
import { Animated } from 'react-native';
import { useEffect, useState, useEffectEvent } from 'react';

function useInterval(callback, delay) {
    const onTick = useEffectEvent(callback);

    useEffect(() => {
        if (delay === null) {
            return;
        }
        const id = setInterval(() => {
            onTick();
        }, delay);
        return () => clearInterval(id);
    }, [delay]);
}

const Alti = ({ startingHeight=3900, width = 600 }) => {
    const [running, setRunning] = useState(false);
    const [height, setHeight] = useState(startingHeight);

    if (height == 0 && running) {
        setRunning(false);
        setHeight(4000);
    }

    useInterval(() => {
        setHeight(c => c - 2.5);
    }, running > 0 ? 50 : null);

    const rotate = new Animated.Value(height).interpolate({
        inputRange: [0, 4000],
        outputRange: ['0deg', '360deg'],
    });

    return (
        <div style={{ height: (width + 100) + 'px' }}>

            <div style={{
                position: "relative",
                //top: 0,
                //left: 0,
                width: width,
                height: width
            }}>

                <img className="figure-img img-fluid rounded"
                    src={barigo} alt={""}
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        height: width,
                        width: width,
                        zIndex: 100
                    }}
                />
                <Animated.View
                    style={{
                        transform: [{ rotate }],
                        position: "absolute",
                        top: 0,
                        left: 0,
                        height: width,
                        width: width,
                        zIndex: 110
                        //backgroundColor: '#33333390',
                    }}
                >
                    <img className="figure-img img-fluid rounded"
                        src={barigoArm} alt={""}
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            height: width,
                            width: width,
                        }}
                    />
                </Animated.View>
            </div>
            <Row style={{ width: width, position: "relative", paddingTop: '15px', zIndex: 120 }}>
                <Button variant="secondary" className='btn-light btn waves-effect waves-light btn-lg '
                    style={{ width: '50%' }} onClick={e => { setHeight(startingHeight); setRunning(false) }}>Reset</Button>
                <Button className='btn-auto btn-lg' style={{ width: '50%' }}
                    onClick={e => { setRunning(!running) }}>{running ? "Stopp" : "Start"}</Button>
            </Row>
        </div>);
}

export default Alti;